import { Routes } from '@angular/router';
import { RouteSlug } from './_models/route-slug.enum';
import { SsrGuard } from './_guards/ssr.guard';
import { AuthGuard } from './_guards/auth.guard';
import { AppSettings } from './app.settings';

export const APP_ROUTES: Routes = [
  {
    path: RouteSlug.SSR_REDIRECT,
    loadComponent: () =>
      import('./ssr-redirect/ssr-redirect.component').then(({ SsrRedirectComponent }) => SsrRedirectComponent),
  },
  {
    path: `${RouteSlug.LIVE_CHAT}/:slug`,
    canActivate: [SsrGuard, AuthGuard],
    loadComponent: () => import('./pages/chat/chat.component').then(({ ChatComponent }) => ChatComponent),
    title: `${AppSettings.TITLE_PREFIX} - Chat`,
  },
  {
    path: `${RouteSlug.SURVEY}/:slug`,
    canActivate: [SsrGuard],
    loadComponent: () => import('./pages/survey/survey.component').then(({ SurveyComponent }) => SurveyComponent),
    title: `${AppSettings.TITLE_PREFIX} - Survey`,
  },
  {
    path: `${RouteSlug.CERAVE_INVITATION}`,
    canActivate: [SsrGuard],
    loadComponent: () => import('./pages/video-lp/video-lp.component').then(({ VideoLpComponent }) => VideoLpComponent),
    title: `${AppSettings.TITLE_PREFIX} - Cerave Invitaion`,
  },
  {
    path: RouteSlug.CONFERENCES,
    canActivate: [SsrGuard],
    loadComponent: () =>
      import('./pages/conferences/conferences.component').then(({ ConferencesComponent }) => ConferencesComponent),
    title: `${AppSettings.TITLE_PREFIX} - Rejestracja`,
  },
  {
    path: '',
    loadChildren: () => import('./pages/core/core.routing').then(({ CORE_ROUTES }) => CORE_ROUTES),
  },
];
